var _path, _path2, _path3, _path4, _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindSpeedAnemometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#6EC1CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13.7377C28 15.1922 26.8209 16.3713 25.3663 16.3713C23.9118 16.3713 22.7327 15.1922 22.7327 13.7377C22.7327 12.2831 23.9118 11.104 25.3663 11.104C26.8209 11.104 28 12.2831 28 13.7377ZM23.5355 13.7377C23.5355 14.7488 24.3552 15.5685 25.3663 15.5685C26.3774 15.5685 27.1971 14.7488 27.1971 13.7377C27.1971 12.7266 26.3774 11.9069 25.3663 11.9069C24.3552 11.9069 23.5355 12.7266 23.5355 13.7377Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0199 10.6337C15.0199 12.0882 13.8408 13.2673 12.3862 13.2673C10.9317 13.2673 9.75256 12.0882 9.75256 10.6337C9.75256 9.17913 10.9317 8 12.3862 8C13.8408 8 15.0199 9.17913 15.0199 10.6337ZM10.5554 10.6337C10.5554 11.6448 11.3751 12.4645 12.3862 12.4645C13.3973 12.4645 14.217 11.6448 14.217 10.6337C14.217 9.62255 13.3973 8.80288 12.3862 8.80288C11.3751 8.80288 10.5554 9.62255 10.5554 10.6337Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2673 18.6288C14.2673 20.0833 13.0882 21.2625 11.6337 21.2625C10.1791 21.2625 9 20.0833 9 18.6288C9 17.1743 10.1791 15.9951 11.6337 15.9951C13.0882 15.9951 14.2673 17.1743 14.2673 18.6288ZM9.7901 18.6288C9.7901 19.647 10.6155 20.4724 11.6337 20.4724C12.6518 20.4724 13.4772 19.647 13.4772 18.6288C13.4772 17.6106 12.6518 16.7852 11.6337 16.7852C10.6155 16.7852 9.7901 17.6106 9.7901 18.6288Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20667_23331",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 22,
    width: 6,
    height: 4
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.07922,
    height: 2.25743,
    transform: "matrix(1 0 0 -1 15.1139 25.0247)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20667_23331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5347 25.0246C19.5347 26.1675 18.6083 27.0939 17.4654 27.0939C16.3226 27.0939 15.3961 26.1675 15.3961 25.0246C15.3961 23.8818 16.3226 22.9553 17.4654 22.9553C18.6083 22.9553 19.5347 23.8818 19.5347 25.0246ZM16.2238 25.0246C16.2238 25.7103 16.7797 26.2662 17.4654 26.2662C18.1511 26.2662 18.707 25.7103 18.707 25.0246C18.707 24.3389 18.1511 23.783 17.4654 23.783C16.7797 23.783 16.2238 24.3389 16.2238 25.0246Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3961,
    y: 25.0247,
    width: 0.827724,
    height: 3.57426,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.707,
    y: 25.0247,
    width: 0.827724,
    height: 3.57426,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5594,
    y: 13.1733,
    width: 5.45545,
    height: 0.846536,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0891,
    y: 23.3318,
    width: 9.68813,
    height: 0.846536,
    transform: "rotate(-90 17.0891 23.3318)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3268,
    y: 16.7214,
    width: 5.45853,
    height: 0.846536,
    transform: "rotate(-41.8564 13.3268 16.7214)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3949,
    y: 11.198,
    width: 4.28097,
    height: 0.846536,
    transform: "rotate(28.9511 14.3949 11.198)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSpeedAnemometer);
export default __webpack_public_path__ + "static/media/wind-speed-anemometer.7933bc74.svg";
export { ForwardRef as ReactComponent };